import { JsonObject } from 'projects/core/src/public-api';
import { TrelloObject } from './trello-object';

@JsonObject('model.trello.TrelloList')
export class TrelloList extends TrelloObject {
}